<div class="mb-5">

  <div (click)="toggleContentContainer()" class="columns card has-round-border px-4 py-0 z-index-1 is-clickable h-55 hover-container">
    <div class="column is-7 is-clickable">
      <p>Planungsrecht</p>
    </div>

    <div class="column is-flex is-justify-content-end is-align-items-center">
      <div *ngIf="customerInteractions && customerInteractions.length > 0 && hasRelevantCustomerInteraction()"
           (click)="navigateToCustomerInteraction($event)"
           class="is-flex icon-24-px">
        <img alt="CI Icon" src="assets/images/InfoIcon/ci_info_icon.svg">
      </div>

      <div *ngIf="!isLoadingStatusMessages && statusMessages.length > 0"
           class="is-flex is-justify-content-end is-align-items-center ml-3">
        <img alt="Status Icon"
             src="{{StatusMessageUtils.getImageForStatusMessage(isLoadingStatusMessages, statusMessages)}}">
      </div>

      <ng-container *ngIf="!isAnyDocumentStillLoading(); else loadingIcon">
        <ng-container *ngIf="hasAnyDocumentAtLeastOneFile()">
          <div class="is-flex is-justify-content-center is-align-items-center ml-3"
               (click)="hasDownloadPermissions() ? downloadDocumentFilesByGroupId(uniqueDocumentFileGroupIds, $event) : $event.stopPropagation()"
               [matTooltip]="showToolTip()">
            <img alt="Download Icon" src="assets/images/download_icon/download_icon_light.svg">
          </div>
        </ng-container>
      </ng-container>

      <ng-template #loadingIcon>
        <ngx-skeleton-loader [theme]="{'width':'30px','height':'30px', 'margin-top':'10px'}" appearance="circle"
                             count="1"></ngx-skeleton-loader>
      </ng-template>

      <ng-container *ngIf="isLoadingStatusMessages" [ngTemplateOutlet]="loadingIcon"></ng-container>
    </div>
  </div>

  <div *ngIf="showContentContainer" class="content-container columns card is-relative is-block">
    <app-status-message #statusMessageComponent [statusMessages]="statusMessages"
                        [isLoadingStatusMessages]="isLoadingStatusMessages"
                        [isHidden]="hasAnyDocumentAtLeastOneFile()"
                        [property]="property"
                        [customerInteractions]="property.customerInteractions"
                        [statusMessageInitializationError]="statusMessageInitializationError"
                        [documents]="planungDocuments"></app-status-message>

    <div class="card has-round-border background-is-gray p-4 w-100 is-size-7 mt-5 mb-5"
         *ngIf="!hasAnyDocumentAtLeastOneFile() && !isAnyDocumentStillLoading()">
      <span>Aktuell sind keine Dokumente verfügbar.</span>
    </div>

    <div class="w-100 mt-5" *ngIf="isAnyDocumentStillLoading()">
      <ng-container *ngFor="let _ of [].constructor(3)">
        <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'100%'}"
                             appearance="line" count="1">
        </ngx-skeleton-loader>
      </ng-container>
    </div>

    <div *ngIf="hasAnyDocumentAtLeastOneFile()" class="mt-5">
      <div *ngIf="!isAnyDocumentStillLoading()"
           class="card m-0 has-round-border z-index-2 w-100 height-40-px has-background-dark-gray"></div>

      <div *ngIf="!isAnyDocumentStillLoading()" class="columns w-100 margin-left-5"
           [style.height.px]="320 + (uniqueDocumentFileGroupIds.length * 45)">
        <div class="column is-relative" *ngFor="let category of planungCategoryNames;"
             [ngClass]="category === 'Download' ? '' : 'bottom-2'">
          <div *ngIf="category !== 'Download'" class="is-relative z-index-2 has-text-white does-not-wrap"
               [ngClass]="category === 'ST' ? 'has-text-left' : 'has-text-centered'">
            {{category}}
          </div>
          <div class="columns w-100 h-100 is-relative z-index-1 max-h-300"
               [ngClass]="category === 'ST' ? 'is-justify-content-start':'is-justify-content-center'">
            <div class="column p-0" [ngClass]="category === 'Download' ? 'max-width-100' : 'max-width-40-px'"
                 *ngFor="let productShortName of planungDocumentClassMap.get(category)">
              <div class="is-relative is-flex is-flex-direction-column h-90">
                <div *ngIf="category !== 'Download'" class="is-full h-100">
                  <div class="card rotate-195 has-round-border mr-4 h-100 background-is-gray"
                       [ngClass]="{'disabled':!isPlanungDocumentOrdered(productShortName)}">
                    <p class="rotate-90 does-not-wrap is-size-7 pl-4 is-bold">{{getProductLongName(productShortName, products, planungDocumentClass)}}</p>
                  </div>
                </div>
                <ng-container *ngFor="let groupId of uniqueDocumentFileGroupIds; let index = index">
                  <div *ngIf="category !== 'Download'" class="is-full planung-check-icon" [ngClass]="{'margin-left-negative-25': areFilesDownloadableForGroupId(groupId, productShortName)}"
                       [style.bottom.px]="-48 - index * 52">
                    <div class="max-width-20-px" [ngClass]="{'disabled':!isPlanungDocumentOrdered(productShortName)}">
                      <svg *ngIf="!areFilesDownloadableForGroupId(groupId, productShortName)"
                           viewBox="159.9808 147.3844 8.0628 8.0522" width="8.0628" height="8.0522"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M 164.012 155.436 C 167.111 155.382 169.048 151.995 167.498 149.339 C 166.779 148.105 165.45 147.36 164.012 147.385 C 160.913 147.437 158.977 150.823 160.526 153.481 C 161.245 154.715 162.573 155.46 164.012 155.436 Z"
                            fill="#828282"/>
                      </svg>
                      <div *ngIf="areFilesDownloadableForGroupId(groupId, productShortName)" class="is-flex">
                        <img alt="Download Icon" src="assets/images/status-messages/information_received_icon.svg">
                      </div>
                    </div>
                  </div>
                  <div *ngIf="category === 'Download'">
                    <div #planungDownloadButton class="planung-category-download-button w-100 max-w-15-rem"
                         [style.bottom.px]="-48 - index * 52">
                      <div (click)="downloadDocumentFilesByGroupId([groupId])"
                           class="card has-round-border is-clickable">
                        <div class="columns is-align-items-center p-1 is-justify-content-space-between">
                          <div class="column is-flex is-justify-content-center">
                            {{dynamicText + ' ' + (index + 1)}}
                            <div class="is-flex ml-2">
                              <img alt="Download Icon" src="assets/images/download_icon/download_icon_light.svg">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngFor="let groupId of uniqueDocumentFileGroupIds; let index = index"
           class="card has-round-border absolute planung-card-background"
           [style.bottom.px]="(320 + (uniqueDocumentFileGroupIds.length * 45)) - (293 + index * 52)"></div>
    </div>
  </div>
</div>
